
let ventas = [
  { id: "3", name: "Entrega" }, 
  { id: "3000", name: "Entrega Combustible" }, 
  { id: "3001", name: "Facturas Ffacsa" }, 
];

let produccion = [
  { id: "2", name: "Control Tiempos Muertos" },
  { id: "4000", name: "Liberar Lotes" },
  { id: "4001", name: "Calculo de Resistencias" },
  { id: "4002", name: "Validar Calculo Resistencias" },
  { id: "4003", name: "Calculo Granulometria" },
  { id: "4004", name: "Certificados de Calidad" },
  { id: "4005", name: "Buzon de Certificados" },
  { id: "4006", name: "Buzon de Certificados" },
];

let compras = [
  { id: "1001", name: "Solicitud de servicio preliminar" }, 
  { id: "1002", name: "Solicitud de articulo preliminar" },   
  { id: "1003", name: "Solicitud compra Articulos" }, 
  { id: "1004", name: "Solicitud compra Servicios" }, 
  { id: "1005", name: "Informe status de Autorizacion" }, 
  { id: "1006", name: "Adjuntar Archivo Cotizacion" }, 
];

let autorizaciones = [
  { id: "2001", name: "Autorizaciones Compras" }, 
  { id: "2002", name: "Autorizaciones Compras V2" }, 
];

let fracttal = [
  { id: "5000", name: "Interface" }, 
];

let logistica = [
  { id: "6000", name: "Ingresar Factura FFACSA" }, 
];

let bodega = [
  { id: "7000", name: "Solicitud de Traslado" }, 
  { id: "7001", name: "Transferencias de Stock" }, 
  { id: "7002", name: "Inventario" }, 
  { id: "7003", name: "Tags" }, 
  { id: "7004", name: "Informe Inventario" }, 
  { id: "7005", name: "Entrada de Mercancias" }, 
  { id: "7006", name: "Entregas" }, 
];




module.exports = {
 
  ventas,  
 
  produccion,  
  
  compras, 

  autorizaciones,

  fracttal,

  logistica,

  bodega
};
